import { CommonConfig, common as commonCore } from "src/index";

export const common: CommonConfig = {
    ...commonCore,
    // Impostare qui gli override per i valori della configurazione comune tra sviluppo e produzione
    id: 'digital-marketing',
    name: 'Digital Marketing',
    logo: 'assets/images/ITS-logo.png',

    defaultLanguage: 'it',
    customLanguageResourcesPrefixes: ['/assets/i18n/'],

    myCoursesModule: {
        hideAdvancedSearch: true,
    },

    myGuidesModule: {
        hideAdvancedSearch: true,
    },

    calendarModule: {
        ...commonCore.calendarModule,
        facetField: 'courseId',
        colorPalette: [
            ...commonCore.calendarModule?.colorPalette ?? [] // To customize comment this line and add custom colors
        ],
    },

    viewerModule: {
        ...commonCore.viewerModule,
        liquidViewer: {
            ...commonCore.viewerModule?.liquidViewer,
            customCssPath: 'assets/liquidViewerCustomizations.css',
        },
        toolbar: {
            ...commonCore.viewerModule?.toolbar!,
            showNewViewerTool: false,
        },
    },

    registrationModule: {
        ...commonCore.registrationModule,
        registrationType: 'simple',
    },

    loginModule: {
        ...commonCore.loginModule,
        hidePasswordForgotten: true,
    }
};
